<template>
  <v-container fluid class="pa-0">

    <v-card class="primary ma-1 mt-2">
      <v-card-title class="text-xs-center">
        <v-flex xs12 class="text-xs-center white--text">
          <b>{{repos.length}} Proyectos</b>
        </v-flex>
      </v-card-title>
    </v-card>

    <v-layout 
      xs10 
      offset-xs1 
      row 
      v-for="repo in repos" :key="repo.id"
      class="ma-1 mb-2"
      >
      <v-flex xs12>
        <v-card>
          <v-toolbar card color="white">
            <v-toolbar-title class="body-2 grey--text">{{repo.name}}</v-toolbar-title>
          </v-toolbar>
          <v-divider></v-divider>
          <v-card-text>
            <i class="fa fa-star"></i> {{repo.stargazers_count}}
            <i class="fa fa-code-fork"></i> {{repo.forks}}
            <i class="fa fa-bug"></i> {{repo.open_issues_count}}
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn :to="`portfolio/${repo.name}`" target="__blank" icon>
              <v-icon>content_paste</v-icon>
            </v-btn>
            <v-btn :href="repo.html_url" target="__blank" icon>
              <v-icon>send</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>


<script>
/* eslint-disable */

const BASE_URL = 'https://api.github.com';
const USER_URL = `${BASE_URL}/users/joseahr`;
const REPOS_URL = `${USER_URL}/repos`;

export default {
  data() {
    return {
      userInfo: null,
      repos: [],
      loading: true,
      isSearching: false,
      search: ''
    };
  },
  watch: {
    isSearching (val) {
      this.$refs.toolbar.isScrolling = !val
      if (val) {
        this.$nextTick(() => {
          this.$refs.search.focus()
        })
      } else {
        this.search = null
      }
    },
    search (val) {
      if (!val) {
      }
    }
  },
  methods: {
    getRepos() {
      console.log('repos')
      this.$http.get(REPOS_URL)
        .then((res) => res.json())
        .then((repos) => {
          this.repos = repos
            //.filter((repo) => !repo.fork)
            .sort((a, b) => new Date(b.updated_at) > new Date(a.updated_at));
        })
        .catch(console.error)
        .then(()=> { this.loading = false; });
    },
    getUserInfo() {
      this.$http.get(USER_URL)
        .then((res) => res.json())
        .then((userInfo) => { this.userInfo = userInfo; });
    },
  },
  created() {
    this.getRepos();
  },
};
</script>


<style lang="stylus">
  .algolia-autocomplete
    flex: 1 1 auto
  #search
    width: 100%
    ~ #algolia-autocomplete-listbox-0
      left: -56px !important
      top: calc(100% + 13px) !important
      elevation(6)
      .ds-dataset-1
        border: none !important
</style>


// WEBPACK FOOTER //
// Portfolio.vue?367b842b